import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles, Theme, Typography } from '@material-ui/core';
import { Button, UnavailableModule } from 'common/components';
import { ReactComponent as ClosedRegisterIcon } from 'img/icons/cash-register-close.svg';
import messages from 'modules/pos-kiosk/messages/messages';
import usePermissionContext from 'common/hooks/context/usePermissionContext';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    gap: theme.spacing(3),
    maxWidth: '100% !important',
    '& > div': {
      padding: 0,
      margin: 0,
    },
  },
  mainText: {
    fontSize: '46px',
    fontWeight: 700,
  },
  bodyText: {
    fontSize: '16px',
    color: theme.palette.secondary.dark,
  },
}));

interface IClosedRegister {
  onOpenRegister: () => void;
}

const ClosedRegister: FC<IClosedRegister> = ({ onOpenRegister }) => {
  const classes = useStyles();
  const intl = useIntl();
  const { OPEN_REGISTER } = usePermissionContext();
  let additionalButton: JSX.Element | null = null;

  if (OPEN_REGISTER) {
    additionalButton = (
      <Button variant="contained" color="primary" onClick={onOpenRegister}>
        {intl.formatMessage(messages.openRegister)}
      </Button>
    );
  }

  return (
    <UnavailableModule
      className={classes.wrapper}
      hasVisibleBackToBtn={false}
      lockIcon={<ClosedRegisterIcon />}
      title={intl.formatMessage(messages.closedRegisterText)}
      description={
        <Typography className={classes.bodyText}>
          {intl.formatMessage(messages.youNeedToOpenRegisterText)}
        </Typography>
      }
      additionalButton={additionalButton}
    />
  );
};

export default ClosedRegister;
